import uuidv4 from "uuid/v4";

export default uuidv4;

export const genUuidV4 = uuidv4;
